export type MaybeUnknown<T extends string> = T | (string & {})

export type ResolutionReason =
  | 'filtered_out'
  | 'unmapped_channel'
  | 'no_registered_action'
  | 'platform_not_writable'
  | 'not_applicable'
  | 'deferred'
  | 'ambiguous_row_key'
  | 'target_unresolved'
  | 'missing_payload_value'
  | 'invalid_payload'

export type RuntimeOutcomeReason =
  | 'already_requested'
  | 'awaiting_approval'
  | 'guardrail_blocked'
  | 'ambiguous_account'
  | 'target_locked'
  | 'blocked_by_pending_item'
  | 'timeout'
  | 'unexpected_error'
  | 'execute_failed'
  | 'partially_applied'
  | 'rejected'
  | 'expired'
  | 'cancelled'
  | 'platform_refused'
  | 'revert_not_eligible'
  | 'action_not_reversible'
  | 'revert_awaiting_approval'
  | 'revert_timeout'
  | 'already_decided'

export type RevertBlockedReason =
  'awaiting_approval' | 'not_succeeded' | 'no_request' | 'not_reversible'

export type InsightActionReason = ResolutionReason | RuntimeOutcomeReason

const RETRYABLE: ReadonlySet<string> = new Set<RuntimeOutcomeReason>([
  'target_locked',
  'blocked_by_pending_item',
  'timeout',
  'revert_timeout',
])

export function isRetryableReason(code?: MaybeUnknown<RuntimeOutcomeReason> | null): boolean {
  return Boolean(code && RETRYABLE.has(code))
}
